import PharmacyOrder from './PharmacyOrder'
import PharmacyBanner from './PharmacyBanner'
import { lazy, Suspense } from 'react'

const BrandedPharmacy = lazy(() => import("./BrandedPharmacy"));
const HealthcareChallenges = lazy(() => import("../healthcare/HealthcareChallenges"));
const PharmacyStep = lazy(() => import("./PharmacyStep"));
const PharmacyGrowth = lazy(() => import("./PharmacyGrowth"));
const HealthIndustries = lazy(() => import("../healthcare/HealthIndustries"));
const FoodSpeed = lazy(() => import("../foodAndGrocery/FoodSpeed"));
const IndustryPricing = lazy(() => import("../industries/IndustryPricing"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. Why is Mobility Infotech the best for medicine delivery app development?",
    answer: "Mobility Infotech stands out because of its expertise in developing custom software tailored to meet the unique needs of the medicine delivery industry. With a focus on user-friendly interfaces, advanced integrations like real-time tracking and secure payment systems, and adherence to healthcare compliance standards, they ensure your business operates seamlessly and efficiently.",
  },
  {
    id: "1",
    question: "02. Can you help us optimize our existing medicine delivery app?",
    answer: "Yes, Mobility Infotech enhances existing applications by improving performance, upgrading features, integrating advanced technologies, and ensuring a smooth user experience. They also ensure the app complies with current regulations and trends in the healthcare industry.",
  },
  {
    id: "2",
    question: "03. Will the online medicine delivery app support multiple payment gateways?",
    answer: "Absolutely. Mobility Infotech's solutions are designed to include multiple payment gateways, offering users flexibility and security. This ensures a seamless checkout experience, accommodating credit cards, digital wallets, UPI, and other popular payment methods.",
  },
  {
    id: "3",
    question: "04. How much will getting a medicine app development solution cost me?",
    answer: "The cost depends on the complexity of the features, design requirements, and integrations needed for your app. Mobility Infotech offers customized pricing based on your specific needs and provides a detailed estimate after assessing your project requirements.",
  },
  {
    id: "4",
    question: "05. Does the app support prescriptions?",
    answer: "The app can be integrated with prescription management systems, enabling users to upload or verify prescriptions securely. For added functionality, it can also include AI-powered prescription analysis and doctor approvals.",
  },
  {
    id: "5",
    question: "06. Can I add multiple branches for the pharmacy?",
    answer: "Yes, Mobility Infotech's apps are scalable and support multi-branch management. From a centralized dashboard, you can manage inventory, orders, and deliveries across multiple locations.",
  },
  {
    id: "6",
    question:
      "07. Is it worth investing in the medicine delivery business?",
    answer: "Investing in the medicine delivery business is highly profitable due to the growing demand for online healthcare solutions. With increasing digital adoption, convenience-focused customers, and the sector's scalability, it’s a lucrative opportunity for both short-term returns and long-term growth.",
  },
  {
    id: "7",
    question: "08. What innovative technologies does Mobility Infotech integrate into its pharmacy software solutions?",
    answer: " Mobility Infotech leverages cutting-edge technologies like AI for personalized medicine recommendations, machine learning for predictive analytics, blockchain for secure transactions, and IoT for real-time inventory tracking. These innovations enhance efficiency, security, and user satisfaction.",
  },
];
export default function Pharmacy() {
  return (
    <>
      <PharmacyBanner />
      <PharmacyOrder />

      <Suspense fallback={null}>
        <BrandedPharmacy />
        <HealthcareChallenges />
        <PharmacyStep />
        <PharmacyGrowth />
        <HealthIndustries />
        <FoodSpeed />
        <IndustryPricing />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
